import type { Meta, StoryObj } from "@storybook/react";

import type { MarkdownProps } from "@/ui/core/Markdown";
import MarkdownParser from "@/ui/core/Markdown";

const StoryMeta: Meta<MarkdownProps> = {
  title: "Core/Markdown",
  component: MarkdownParser,
  argTypes: {
    content: { control: "text" },
    role: { control: "text" },
  },
  args: {
    content: "# Heading\n\nThis is a **Markdown** example.",
  },
};

type Story = StoryObj<MarkdownProps>;

const Default: Story = {};

const ComplexContent: Story = {
  args: {
    content: `
# Markdown Example

- **Bold Text**
- *Italic Text*
- [Link](https://example.com)

> Blockquote
    `,
  },
};

const WithLink: Story = {
  args: {
    content: `
# Markdown with Link

Here is a [link to Google](https://www.google.com).
        `,
  },
};

export { ComplexContent, Default, WithLink };
export default StoryMeta;
